var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { DraftLayoutRight } from './DraftLayoutRight';
import { DraftLayoutLeft } from './DraftLayoutLeft';
let DraftLayoutMain = class DraftLayoutMain extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get templateMain() {
        return (React.createElement("div", { key: "stage_main", style: {
                flex: '1 1 auto',
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'space-between',
                zIndex: 1,
            } }));
    }
    get templateInner() {
        const { app } = this.props;
        return (React.createElement("div", { key: "stage_inner", style: {
                height: app.stage.draftLayout.height,
                width: app.stage.draftLayout.width,
                flex: `0 0 ${app.stage.draftLayout.width}px`,
            } }));
    }
    render() {
        const { app, children } = this.props;
        return (React.createElement(Aspect_, { aspect: app.stage.ownAspect.main, templateComponent: this.templateMain },
            React.createElement(DraftLayoutLeft, { app: app }),
            React.createElement(Aspect_, { aspect: app.stage.inner, templateComponent: this.templateInner }, children),
            React.createElement(DraftLayoutRight, { app: app })));
    }
};
__decorate([
    memoize
], DraftLayoutMain.prototype, "templateMain", null);
__decorate([
    computed
], DraftLayoutMain.prototype, "templateInner", null);
DraftLayoutMain = __decorate([
    observer
], DraftLayoutMain);
export { DraftLayoutMain };
